// 案件一覧（申込人）の定数

// ご案内一覧（顧客宛文書のリスト）の最大件数
export const information_max_count = 100;
